var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "exchange-rate",
      class: { "visibility-hidden": !_vm.quote },
    },
    [
      _vm.selectedCurrency &&
      _vm.quote &&
      _vm.currencyIsAllowed &&
      !(_vm.showLoyaltyCTA && _vm.isSignedInToLoyalty)
        ? _c("p", { staticClass: "exchange exchange-rate--standard" }, [
            _c("b", [
              _vm._v(_vm._s(_vm.content.standardRateLabel || "Exchange rate")),
            ]),
            _vm._v(
              "\n      £1 = " +
                _vm._s(_vm.selectedCurrency.symbol) +
                _vm._s(_vm.rate.toFixed(4)) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedCurrency &&
      _vm.quote &&
      _vm.currencyIsAllowed &&
      _vm.showLoyaltyCTA &&
      _vm.isSignedInToLoyalty
        ? _c("p", { staticClass: "exchange exchange-rate--loyalty" }, [
            _c("b", [
              _vm._v(_vm._s(_vm.content.loyaltyRateLabel || "Loyalty rate")),
            ]),
            _vm._v(
              "\n      £1 = " +
                _vm._s(_vm.selectedCurrency.symbol) +
                _vm._s(_vm.rate.toFixed(4)) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedCurrency &&
      _vm.quote &&
      _vm.isSellTransaction &&
      !_vm.selectedCurrency.purchaseAllowed
        ? _c("p", { staticClass: "no-exchange-allowed" }, [
            _vm.content.noPurchaseAllowedMessage
              ? _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.content.noPurchaseAllowedMessage.replace(
                          "{currency}",
                          _vm.selectedCurrency.pluralName
                        )
                      ) +
                      "\n    "
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "\n      Oh snap! We don't have any " +
                      _vm._s(_vm.selectedCurrency.pluralName) +
                      " right now - check back soon!\n    "
                  ),
                ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedCurrency &&
      _vm.quote &&
      _vm.isBuyTransaction &&
      !_vm.selectedCurrency.sellBackAllowed
        ? _c("p", { staticClass: "no-exchange-allowed" }, [
            _vm.content.noSellBackAllowedMessage
              ? _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.content.noSellBackAllowedMessage.replace(
                          "{currency}",
                          _vm.selectedCurrency.pluralName
                        )
                      ) +
                      "\n    "
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "\n      Oh snap! We can't buy " +
                      _vm._s(_vm.selectedCurrency.pluralName) +
                      " right now - check back soon!\n    "
                  ),
                ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showLoyaltyCTA && !_vm.isSignedInToLoyalty
        ? _c("LoyaltyCTA", {
            attrs: {
              preamble:
                _vm.content.loyaltyCTAPreamble ||
                "Get a better rate by signing in",
              text: _vm.content.loyaltyCTAText || "Sign In",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }